import { forwardRef, type InputHTMLAttributes } from 'react';
import { cx } from './cx.js';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** `lg` for till screens. */
  inputSize?: 'md' | 'lg';
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { inputSize = 'md', className, ...rest },
  ref,
) {
  return (
    <input ref={ref} className={cx('qk-input', `qk-input--${inputSize}`, className)} {...rest} />
  );
});
